import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    // K-pop inspired vibrant color palette
    primary: '#ff358b',     // Neon pink
    secondary: '#01cdfe',   // Bright blue
    accent1: '#05ffa1',     // Neon green
    accent2: '#b967ff',     // Purple
    dark: '#1a1a1a',        // Near black
    light: '#f1f1f1',       // Off white
    background: '#121212',  // Very dark gray
    backgroundAlt: '#1e1e1e', // Slightly lighter dark gray
    overlay: 'rgba(0, 0, 0, 0.8)', // Dark overlay
    cardBackground: 'rgba(255, 255, 255, 0.05)' // Glass effect background
  },
  fonts: {
    main: "'Poppins', sans-serif",
    korean: "'Noto Sans KR', sans-serif"
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    largeDesktop: '1200px'
  },
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease'
  },
  shadows: {
    small: '0 2px 5px rgba(0, 0, 0, 0.15)',
    medium: '0 5px 15px rgba(0, 0, 0, 0.2)',
    large: '0 10px 25px rgba(0, 0, 0, 0.3)',
    neon: (color: string) => `0 0 10px ${color}, 0 0 20px ${color}`
  },
  gradients: {
    primary: 'linear-gradient(to right, #ff358b, #01cdfe)',
    secondary: 'linear-gradient(135deg, #05ffa1, #b967ff)',
    card: 'linear-gradient(135deg, rgba(255, 53, 139, 0.7), rgba(1, 205, 254, 0.7))'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    circle: '50%'
  },
  spacing: {
    xs: '0.25rem', // 4px
    sm: '0.5rem',  // 8px
    md: '1rem',    // 16px
    lg: '1.5rem',  // 24px
    xl: '2rem',    // 32px
    xxl: '3rem'    // 48px
  }
};

export default theme; 